import React from 'react';
import './Footer.css';

const Footer = ({ setShowMentionsLegales, isRelative }) => {
  return (
    <div className={`footer ${isRelative ? "relative" : "fixed"}`}>
      {/* Ici, on remplace 2024 par du code dynamique */}
      La Ferme du Fersac © {new Date().getFullYear()} – Tous droits réservés - 
      <span
        className="footer-link"
        onClick={() => setShowMentionsLegales(true)}
      >
        &nbsp;CGV & Mentions légales
      </span>
    </div>
  );
};

export default Footer;